import { SagaIterator } from '@redux-saga/core';
import { all, takeLatest, put, call } from 'redux-saga/effects';

import { statusMessageSaga } from 'pages/AppManagement/saga';
import { RequestSagaParams } from 'types';
// import { getDecodedQueryParams } from 'utils';

import { getTagsByMarketer } from 'containers/UploadForm/slice';
import * as Actions from './slice';
import * as Endpoints from './endpoints';
import { mapContentCreateData, mapContenUpdateData } from './mappings';

export function* getVideoList({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.getVideoList, payload);
    yield put(Actions.fetchVideoListSuccess(response.data));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchVideoListFailure(error));
  }
}

export function* postUpload({ payload }: RequestSagaParams): SagaIterator {
  try {
    const { contentData, mediaUploadForm, conversionCTA, newTags, allTags } = mapContentCreateData(
      payload.data,
      payload.marketerId
    );

    const response = yield call(Endpoints.postUploadContent, contentData);
    if (response.data.id) {
      yield call(Endpoints.putMediaContent, mediaUploadForm, response.data.id);

      if (conversionCTA) {
        const ctaResponse = yield call(Endpoints.postConversionToCTA, conversionCTA);
        if (ctaResponse && ctaResponse.data.id) {
          yield call(Endpoints.putUpdateCTA, response.data.id, ctaResponse?.data?.id);
        }
      }
      yield all(
        newTags.map((item: any) => {
          return call(Endpoints.createTagWithCategory, item.name, item.category);
        })
      );
      yield call(Endpoints.putUploadTags, response.data.id, { tags: allTags });
    }

    if (newTags) {
      yield put(getTagsByMarketer({}));
    }

    if (payload.callBack) {
      yield call(payload.callBack);
    }
    yield put(Actions.postUploadSuccess());
    yield call(statusMessageSaga, { type: 'success', message: 'Successfully uploaded the content' });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.postUploadFailure(error));
    if (payload.errorCallBack) {
      yield call(payload.errorCallBack);
    }
  }
}

export function* updateUpload({ payload }: RequestSagaParams): SagaIterator {
  const { data, id, callBack, previousData, previousConversion, previousTags, errorCallBack } = payload;
  try {
    const { contentData, conversionCTA, removeConversionCTA, newTagCreatedCategory, newTaglist, mediaUploadForm } =
      mapContenUpdateData(data, previousData, previousConversion, previousTags);

    if (mediaUploadForm) {
      yield call(Endpoints.putMediaContent, mediaUploadForm, id);
    }

    if (contentData) {
      yield call(Endpoints.putUploadContent, id, contentData);
    }
    if (conversionCTA) {
      const ctaResponse = yield call(Endpoints.postConversionToCTA, conversionCTA);
      if (ctaResponse && ctaResponse.data.id) {
        yield call(Endpoints.putUpdateCTA, payload.id, ctaResponse?.data?.id);
      }
    }

    if (removeConversionCTA) {
      yield call(Endpoints.putUpdateCTA, payload.id, '');
    }

    if (newTagCreatedCategory) {
      yield all(
        Object.keys(newTagCreatedCategory).map((item: string) => {
          return call(Endpoints.createTagWithCategory, item, newTagCreatedCategory[item]);
        })
      );

      // yield put(getTagsByMarketer({}));
    }

    if (newTaglist) {
      yield call(Endpoints.putUploadTags, payload.id, { tags: newTaglist });
    }
    yield put(getTagsByMarketer({}));
    if (callBack) {
      yield call(callBack);
    }
    yield put(Actions.updateUploadSuccess());
    yield call(statusMessageSaga, { type: 'success', message: 'Successfully uploaded the content' });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.updateUploadFailure(error));
    if (errorCallBack) {
      yield call(errorCallBack);
    }
  }
}

export function* postModeration({ payload }: RequestSagaParams): SagaIterator {
  try {
    // const params = getDecodedQueryParams() as { status: string };
    yield all(
      payload.id.map((item: string) =>
        call(Endpoints.putModerationStatus, { id: item, type: payload.type, message: payload?.message || '' })
      )
    );
    // yield put(Actions.fetchVideoList({ marketerId: payload.marketerId, status: params.status }));
    if (payload.callBack) {
      yield call(payload.callBack);
    }
    yield put(Actions.postModerationSuccess());
    yield call(statusMessageSaga, { type: 'success', message: 'Successfully Approved the content' });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.postModerationFailure(error));
  }
}

export function* putReview({ payload }: RequestSagaParams): SagaIterator {
  try {
    // const params = getDecodedQueryParams() as { status: string };
    yield all(
      payload.id.map((item: string) =>
        call(Endpoints.putReviewStatus, { contentId: item, message: payload?.message || '' })
      )
    );
    if (payload.callBack) {
      yield call(payload.callBack);
    }
    yield put(Actions.putReviewSuccess());
    yield call(statusMessageSaga, { type: 'success', message: 'Content Sent to Review' });
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.putReviewFailure(error));
  }
}

export function* UploadManagementWatcherSaga(): SagaIterator {
  yield all([
    yield takeLatest(Actions.fetchVideoList.type, getVideoList),
    yield takeLatest(Actions.postUpload.type, postUpload),
    yield takeLatest(Actions.postModeration.type, postModeration),
    yield takeLatest(Actions.putReview.type, putReview),
    yield takeLatest(Actions.updateUpload.type, updateUpload)
  ]);
}

export default UploadManagementWatcherSaga;
